module.exports = __webpack_public_path__ + "img/BE.0868d7aa.png";